import { shorthands } from '@fluentui/react-components';
import { getInlineDownloadStyle, helpbuttonStyle, datePickerStyle } from '@bingads-webui-campaign-react/common-styles';

export const inlineDownloadStyle = (_, theme) => ({
  '@global': {
    ...datePickerStyle(theme),
  },
  InlineDownloadWrapper: {
    marginTop: '24px',
    position: 'relative',
    zIndex: '11',
    ...getInlineDownloadStyle({}),
    '& button.btn': {
      marginRight: '8px',
    },
    "& input[type='checkbox']": {
      bottom: '0',
    },
    '& .helpbutton': helpbuttonStyle({})['.helpbutton'],
    '& .helpbutton::before': {
      ...helpbuttonStyle({})['.helpbutton::before'],
      position: 'static',
      top: 'unset',
    },
    '& .helpbutton:after': {
      content: 'none',
    },
    '& .glyphicon-remove': {
      // color: `${theme.palette.themePrimary}`,
    },
    '& .form-horizontal .form-group': {
      marginLeft: '0',
      marginRight: '0',
    },
    '& .panel': {
      boxShadow: 'none',
      '& .panel-heading ': {
        ...shorthands.padding('0px'),
        fontWeight: '600',
        '& .panel-title': {
          fontSize: '20px',
          fontWeight: '600',
          lineHeight: '27px',
        },
      },
      '& .panel-body': {
        lineHeight: '19px',
        paddingLeft: '0px',
        marginBottom: '18px',
        paddingBottom: '0px',

        '& .helpbutton': {
          marginLeft: '7px',
        },
      },
    },
  },
});
